export default "__VITE_ASSET__DSwbh9G$__"